import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { MovieModel, MovieLinkInfoModel, MovieViewLogFliter, MovieViewLogModel, Comment } from '../interfaces/movie.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CategoryMoviesModel } from '../interfaces/category.model';
import { MovieLinkInfoTCC2 } from '../interfaces/movieLink2.model';
//import { Tag_Type } from 'src/app/pages/tag-search/tag-search.component';

@Injectable({
  providedIn: 'root',
})
export class MoviesService {
  baseUrl = `${environment.apiEndpoint}/Movie`;
  carteleraPage = 1;
  public cargando: boolean = false;

  constructor(private http: HttpClient) { }

  getAllMovies(): Observable<MovieModel[]> {
    return this.http.get<MovieModel[]>(`${this.baseUrl}/GetOnlineMovies`);
  }

  getOnlineMoviesInRange(from: number, take: number): Observable<MovieModel[]> {
    return this.http.get<MovieModel[]>(`${this.baseUrl}/GetOnlineMoviesInRange?from=${from}&take=${take}`);
  }

  GetFelixOliverOnlineMovies(): Observable<MovieModel[]> {
    return this.http.get<MovieModel[]>(`${this.baseUrl}/GetFelixOliverOnlineMovies`);
  }

  getMovieById(id: Number) {


    if (localStorage.getItem('cinemateca_token') === null) {
      return this.http.get<MovieModel>(`${this.baseUrl}/GetById?Id=${id}`, {});
    }
    else {
      const headers = new HttpHeaders().set(
        'Authorization',
        `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
      );

      return this.http.get<MovieModel>(`${this.baseUrl}/GetById?Id=${id}`, { headers });
    }
  }

  searchMovies(title: string): Observable<MovieModel[]> {
    return this.http
      .get<MovieModel[]>(`${this.baseUrl}/Search/` + title);
    //.pipe(map((movies) => movies.filter((movie) => movie.title.toUpperCase().indexOf(title.toUpperCase()) > -1)));
  }

  getMovieGenre(genreId: number): Observable<MovieModel[]> {
    return this.http
      .get<MovieModel[]>(`${this.baseUrl}/GetOnlineMovies`)
      .pipe(map((movies) => movies.filter((movie) => movie.genreId === genreId)));
  }

  getMovieIsAvailable(id: number): Observable<any> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );
    const params = new HttpParams().append('movieId', String(id));
    return this.http.get<any>(`${this.baseUrl}/GetIsAvailable`, { params, headers });
  }

  getMovieLinkInfo(id: number): Observable<MovieLinkInfoModel> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    ).set('sectionToken', `${localStorage.getItem('cinemateca_cafToken')}`);

    const params = new HttpParams().append('movieId', String(id));
    return this.http.get<MovieLinkInfoModel>(`${this.baseUrl}/GetMovieLinkInfo`, { params, headers });
  }

  getMovieLinkInfoTCC(id: number): Promise<MovieLinkInfoTCC2> {
    return new Promise((resolve, reject) => {
      const headers = new HttpHeaders().set(
        'Authorization',
        `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
      );

      const params = new HttpParams().append('movieId', String(id));
      this.http.get<MovieLinkInfoTCC2>(`${this.baseUrl}/GetMovieLinkInfoTCC`, { params, headers }).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  getMovieLinkInfoTCCExists(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const params = new HttpParams().append('movieId', String(id));
      this.http.get<MovieLinkInfoTCC2>(`${this.baseUrl}/GetMovieLinkInfoTCCExists`, { params }).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  getFeaturedMovies(): Observable<MovieModel[]> {
    return this.http.get<MovieModel[]>(`${this.baseUrl}/GetFeaturedMovies`);
  }

  GetFeaturedMoviesFromCategory(): Observable<MovieModel[]> {
    return this.http.get<MovieModel[]>(`${this.baseUrl}/GetFeaturedMoviesFromCategory`);
  }

  //Felix Oliver
  getFeaturedMoviesFelixOliver(): Observable<MovieModel[]> {
    return this.http.get<MovieModel[]>(`${this.baseUrl}/GetFeaturedMoviesFO`);
  }

  getFilmArchiveMovie(): Observable<MovieModel> {
    return this.http.get<MovieModel>(`${this.baseUrl}/GetFilmArchiveMovie`);
  }

  getCinemaMovies(): Observable<MovieModel[]> {
    return this.http.get<MovieModel[]>(`${this.baseUrl}/GetCinemaMovie`);
  }

  getPressMovies(): Observable<MovieModel[]> {
    return this.http.get<MovieModel[]>(`${this.baseUrl}/GetPressMovie`);
  }

  getMoviePrice(idMovie: number) {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );
    return this.http.get(`${this.baseUrl}/getPrice?Id=${idMovie}`, { headers });
  }

  searchMovie(termino: string) {
    return this.http.get<MovieModel[]>(`${this.baseUrl}/Search/${termino}`);
  }

  getMonthPopular(): Observable<MovieModel[]> {
    return this.http.get<MovieModel[]>(`${this.baseUrl}/GetMonthPopular`);
  }

  GetFavoritesUserFilms(userId: Number): Observable<MovieModel[]> {
    return this.http.get<MovieModel[]>(`${this.baseUrl}/GetFavoritesUserFilms?userId=${userId}`);
  }

  //#region Movie View Logs

  getMoviesSeenByUser(filter: MovieViewLogFliter): Observable<MovieViewLogModel[]> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );

    return this.http.post<MovieViewLogModel[]>(`${environment.apiEndpoint}/MovieViewLog/GetUserSeenMovies`, filter, { headers });
  }

  getUserTotalSeen(filter: MovieViewLogFliter): Observable<number> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );

    return this.http.post<number>(`${environment.apiEndpoint}/MovieViewLog/GetUserTotalSeen`, filter, { headers });
  }

  getUserMonthlySeen(filter: MovieViewLogFliter): Observable<number> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );

    return this.http.post<number>(`${environment.apiEndpoint}/MovieViewLog/GetUserMonthlySeen`, filter, { headers });
  }

  //#endregion

  //#region Comments

  getCommentsByUser(userId: number): Observable<Comment[]> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );

    return this.http.get<Comment[]>(`${environment.apiEndpoint}/comment/GetByUserWeb/${userId}`, { headers });
  }

  getCommentsByMovie(id: number) {
    return this.http.get<Comment[]>(`${environment.apiEndpoint}/comment/GetByMovie/${id}`);
  }

  getCommentReplies(id: number) {
    return this.http.get<Comment[]>(`${environment.apiEndpoint}/comment/GetCommentReplies/${id}`);
  }

  getMonthPopularComments() {
    return this.http.get<Comment[]>(`${environment.apiEndpoint}/comment/GetMonthPopularReviews/`);
  }

  getCriticsReviews() {
    return this.http.get<Comment[]>(`${environment.apiEndpoint}/comment/GetCriticsReviews/`);
  }

  publishComment(newComment: Comment) {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );
    return this.http.post(`${environment.apiEndpoint}/comment/Add`, newComment, { headers });
  }

  getMoviesByTag(tag: Tag_Type, criteria: string): Observable<MovieModel[]> {
    return this.http.get<MovieModel[]>(`${this.baseUrl}/GetMoviesByTag?tag=${tag}&criteria=${criteria}`);
  }

  //#endregion

  //#region Home Storage

  home_moviesSlideshow: MovieModel[] = [];
  home_moviesPerCategories: CategoryMoviesModel[] = [];

  store_HomeMoviesSlideshow(movies: MovieModel[]) {
    this.home_moviesSlideshow = movies;
  }
  get_HomeMoviesSlideshow(): MovieModel[] {
    return this.home_moviesSlideshow;
  }

  store_HomeMoviesPerCategories(moviesCats: CategoryMoviesModel[]) {
    this.home_moviesPerCategories = moviesCats;
  }
  get_HomeMoviesPerCategories(): CategoryMoviesModel[] {
    return this.home_moviesPerCategories;
  }

  //#endregion

}

//Enum necesario para hacer las busquedas de tags. Lo creo en el servicio para que este disponible en un scope grande.
export enum Tag_Type {
  actor,
  anio,
  director,
  pais,
  tema,
  idioma,
  categorias,
  genero,
  production,
  script,
  photography,
  sound,
  music,
  edition,
  artDirection,
  productionCompany,
}